/* tslint:disable */
/* eslint-disable */
/* @relayHash 2b7d766f6bb1162a5cbe97a06425d34e */

import { ConcreteRequest } from "relay-runtime";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type DesignProfileStatusMutationInput = {
    firmId?: number | null;
    serviceId?: number | null;
    status?: DesignProfileStatus | null;
    clientMutationId?: string | null;
};
export type profileStatusMutationVariables = {
    input: DesignProfileStatusMutationInput;
};
export type profileStatusMutationResponse = {
    readonly designProfileStatusMutation: {
        readonly tradeFirm: {
            readonly profileStatus: DesignProfileStatus | null;
        } | null;
    } | null;
};
export type profileStatusMutation = {
    readonly response: profileStatusMutationResponse;
    readonly variables: profileStatusMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DesignProfileStatusMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "profileStatus",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "profileStatusMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "designProfileStatusMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DesignProfileStatusMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "profileStatusMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "designProfileStatusMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DesignProfileStatusMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "profileStatusMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/profileStatusMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '35c7cbeb9630923afa49ed1d22656d45';
export default node;
